export default __webpack_public_path__ + "static/202-1ec274b9a32847de567b54425d9743bc.gif";